import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getGlobalProcedureList } from '../utils/urls';

import { ProcedureDetailsType } from 'types/procedureBuilder';
import { ErrorModal } from 'types/modalTypes';

async function fetchGlobalProcedures({
  accountId,
}: TVariables): Promise<TResult> {
  const response = await fetch(getGlobalProcedureList(accountId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<ProcedureDetailsType>;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
};

function useGetGlobalProcedureList(
  accountId: number,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_global_procedures', accountId],
    async () => {
      if (accountId)
        return await fetchGlobalProcedures({
          accountId,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetGlobalProcedureList };
